import { render, staticRenderFns } from "./StudioMobileMenu.vue?vue&type=template&id=4632b908&scoped=true&"
import script from "./StudioMobileMenu.vue?vue&type=script&lang=ts&"
export * from "./StudioMobileMenu.vue?vue&type=script&lang=ts&"
import style0 from "./StudioMobileMenu.vue?vue&type=style&index=0&id=4632b908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4632b908",
  null
  
)

export default component.exports